import {
  CONVERTVIRTUAL_TO_PHYSICALCARD_SUCCESS,
  CONVERTVIRTUAL_TO_PHYSICALCARD_FAILED,
  CONVERTVIRTUAL_TO_PHYSICALCARD_INVALID_REQUEST,
  LOADING_CONVERTVIRTUAL_TO_PHYSICALCARD,
  CONVERTVIRTUAL_TO_PHYSICALCARD_NOTFOUND,
  RESET_CONVERTVIRTUAL_TO_PHYSICALCARD
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  success: false,
  networkError: "",
  status: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_CONVERTVIRTUAL_TO_PHYSICALCARD:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        notFound: false,
        success: false,
        networkError: "",
        status: {}
      };
    case CONVERTVIRTUAL_TO_PHYSICALCARD_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: false,
        failed: true,
        networkError: "",
        status: action.payload.status
      };

    case CONVERTVIRTUAL_TO_PHYSICALCARD_NOTFOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: true,
        failed: false,
        networkError: "",
        status: action.payload.status
      };
    case CONVERTVIRTUAL_TO_PHYSICALCARD_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        notFound: false,
        failed: false,
        networkError: "",
        status: action.payload.status
      };
    case CONVERTVIRTUAL_TO_PHYSICALCARD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        notFound: false,
        networkError: "",
        status: action.payload.status
      };

    case RESET_CONVERTVIRTUAL_TO_PHYSICALCARD:
      return (state = initialState);

    default:
      return state;
  }
};
